export class RequestState {
  state: "idle" | "in-progress" | "cancelled" | "error" | "success" = "idle";
  error: Error | string | null = null;
}
